export interface stripImages {
  prePath?: string
  imgSources: string[]
}

export const teamImages: stripImages = {
  prePath: 'about-us/',
  imgSources: [
    'achievement-pitch',
    'food-paella',
    'air-floatus',
    'cat-in-box',
    'digging-in',
    'focused-gamers',
    'focus-zone',
    'food-pizza',
    'gather-hug',
    'gather-smile',
    'food-and-drinks',
    'hike-sunrise',
    'mic-check',
    'mom-baby',
    'noodle-group',
    'pitch-finca',
    'foood',
    'pool-work',
    'presentation',
    'quinny',
    'remote-work',
    'pizzza',
    'yoga-pool',
  ],
}

export const coinImages: stripImages = {
  prePath: 'coins/integrations/',
  imgSources: [
    'zendesk-coin',
    'salesforce-coin',
    'zapier-coin',
    'teams-coin',
    'slack-coin',
    'trello-coin',
    'planner-coin',
    'shortcut-coin',
    'webhooks-coin',
    'jira-coin',
    'github-coin',
    'intercom-coin',
    'azure-coin',
    'asana-coin',
  ],
}
